"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPaintStyle = void 0;
var utils_1 = require("../../../utils");
var paint_style_default_1 = require("../../default-values/paint-style-default");
exports.IPaintStyle = (0, utils_1.IRecord)(paint_style_default_1.paintStyleDefault);
